"use strict";

var uniqBy = require("lodash/uniqBy");
/**
 * Removes duplicate marks from an array
 *
 * @param {Array} marks The marks to remove duplications from
 * @returns {Array} A list of de-duplicated marks.
 */
function removeDuplicateMarks(marks) {
    return uniqBy(marks, function (mark) {
        return mark.getOriginal();
    });
}
module.exports = removeDuplicateMarks;
//# sourceMappingURL=removeDuplicateMarks.js.map
//# sourceMappingURL=removeDuplicateMarks.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/markers/removeDuplicateMarks.js
// module id = 470
// module chunks = 0